import './styles.scss';

import ActionsDropdown from '@/components/ActionsDropdown';

import { ItemType } from 'antd/es/menu/interface';
import { PopupTypes } from '@/common/Popup/types';
import { useMemo } from 'react';

const PopupMenuDropdown = ({ items = [], onClick, ...props }: PopupTypes.MenuProps): JSX.Element => {
  const actions = useMemo<ItemType[]>((): ItemType[] => {
    const views: ItemType[] = [
      { label: 'Drawer', key: 'drawer' },
      { label: 'Modal', key: 'modal' },
    ];
    if (!items?.length) return views;
    return [
      ...items,
      { type: 'divider' },
      {
        key: 'view',
        label: 'View',
        children: views,
      },
    ];
  }, [items]);

  const handleClick = (key: string): void => {
    if (key === 'drawer' || key === 'modal') onClick(key);
  };

  return <ActionsDropdown {...props} onClick={handleClick} items={actions} />;
};

export default PopupMenuDropdown;
